<template>
  <div class="contentProduct"
       id="contentProduct">
    <div class="box-card">
      <div class="card-header clearfix">
        <span>收货信息</span>
      </div>
      <div class="box-content">
        <div class="item clearfix">
          <label>姓名</label>
          <div class="value">
            <input type="text"
                   placeholder="请输入姓名"
                   v-model="form.name">
          </div>
        </div>
        <div class="item clearfix phone">
          <label>手机号</label>
          <div class="value"
               v-if="account.mobile&&account.mobile.length==11">
            {{account.mobile}}
            <span @click="logout"
                  style="margin-left:10px;color:#229ef6;float:right">换个手机号</span>
          </div>
          <div class="value"
               v-else>
            <input type="text"
                   placeholder="请输入手机号"
                   maxlength="11"
                   v-model="form.phone">
            <van-button type="danger"
                        @click="getCode"
                        :disabled="disabled?true:false"
                        size="small">
              <span>
                <span v-if="count">{{count}} 秒</span>
                <span v-else>发送验证码</span>
              </span>
            </van-button>
          </div>
        </div>
        <div class="item clearfix"
             v-if="!(account.mobile&&account.mobile.length==11)">
          <label>验证码</label>
          <div class="value">
            <input type="text"
                   placeholder="请输入验证码"
                   maxlength="4"
                   v-model="code">
          </div>
        </div>
        <div class="item city clearfix"
             @click="popupVisible=true">
          <label class="cell-title">
            <span v-if="false">GPS定位</span>
            <span v-else>省市区</span>
          </label>
          <span class="cell-value"
                style="width:70%;font-size:0.14rem;color:#888">
            <span v-if="form.city"
                  class="right">{{form.city}}</span>
            <span v-else
                  class="right">请选择省市区</span>
          </span>
          <span style="font-size:0.14rem;color: rgb(34, 158, 246);float:right"
                v-if="false">修改</span>
          <van-icon name="arrow"
                    class="item-right" />
        </div>
        <van-popup v-model="popupVisible"
                   position="bottom">
          <div class="addtit">
            选择省市区
            <i class="iconfont icon-close"
               @click="popupVisible=!popupVisible"></i>
          </div>
          <v-distpicker type="mobile"
                        class="address-pricker-wrapper"
                        style
                        :placeholders="{ province: '选择省份', city: '选择城市', area: '选择区/县' }"
                        @selected="onSelected"></v-distpicker>
        </van-popup>
        <div class="item clearfix">
          <label>地址</label>
          <div class="value">
            <input type="text"
                   placeholder="请输入详细地址"
                   v-model="form.address">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { encrypt, setCookie } from "@/utils";
import VDistpicker from "@/components/Mobile/Common/Distpicker";
export default {
  props: ["account"],
  data () {
    return {
      userAgent:navigator.userAgent.toLowerCase(),
      active: 2,
      ordersn: {},
      checked: true,
      popupVisible: false,
      count: "",
      disabled: true,
      form: {
        name: "",
        city: "北京市 , 北京, 东城区",
        phone: "",
        address: "",
      },
      code: "",
      smscode: "8686"
    };
  },
  computed: {
    info () {
      return this.$store.state.user.info;
    },
    wechatauthor () {
      return this.$store.state.wechat.wechatauthor;
    },
  },
  components: {
    VDistpicker
  },
  mounted () {
    this.form = this.info;
  },
  methods: {
    onSelected (data) {
      window._hmt.push([
        "_trackEvent",
        "选择省市区",
        "点击",
        JSON.stringify(data)
      ]);
      this.form.city =
        data.province.value + " ," + data.city.value + " ," + data.area.value;
      this.$store.commit("user/setArea", data.city.value);
      this.popupVisible = false;
    },
    BonusList (userid, amount) {
      let params = {
        id: userid,
        type: 1,
        amount: amount,
        shoptype: 1
      };
      this.$store.dispatch("user/fetchBonusList", { params }).then(() => {
        if (this.$store.state.user.bonuslist.length) {
          this.$store.commit('user/setBonus', this.$store.state.user.bonuslist[0])
        }
      });
    },
    openPicker () {
      this.$refs.picker.open();
    },
    handleConfirm (value) {
      this.newDate = getNowFormatDate(value);
      this.$emit("setBestDate", this.newDate);
    },
    getCode () {
      window._hmt.push([
        "_trackEvent",
        "发送验证码",
        "点击",
        "手机号",
        this.phone
      ]);
      const TIME_COUNT = 59;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.disabled = true;
        this.sendSms();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.disabled = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    sendSms () {
      let smscode = Math.round(9000 * Math.random() + 1000).toString();
      this.smscode = smscode;
      let params = {
        smscode: smscode,
        phone: this.form.phone
      };
      this.$store.dispatch("account/fetchSmsData", { params }).then(() => {
        if (this.$store.state.account.sms.code !== 200) {
          this.$toast("验证码发送失败,请稍后再试.");
        } else {
          this.$toast("验证码发送成功.");
        }
      });
    },
    logout () {
      this.code = ''
      this.smscode = parseInt((Math.random() * 9 + 1) * 1000).toString()
      this.$store.commit('account/setUserMobile', '')
    },
    onLogin () {
      let parent_id = 0;
      if (localStorage.code) {
        parent_id = localStorage.code;
      }
      let params = {
        phone: this.form.phone,
        parentId: parent_id,
        openId: this.wechatauthor.openid
      };
      this.$store.dispatch("account/fetchLoginData", { params }).then(() => {
        if (this.$store.state.account.user.userid) {
          this.BonusList(this.$store.state.account.user.userid, this.$store.state.product.product.price);
          let account = JSON.stringify(this.$store.state.account.user);
          setCookie("account", encrypt(account), true);
          this.$toast("用户登录成功.");
        } else {
          this.$toast("用户登录失败.");
        }
      });
    },
    updateUser () {
      let params = {
        phone: this.form.phone,
        userId: this.account.userId
      }
      this.$store.dispatch('account/fetchUpdateUser', { params }).then(() => {
        console.log(this.$store.state.account.user)
        if (this.$store.state.account.user.userId) {
          this.BonusList(this.$store.state.account.user.userid, this.$store.state.product.product.price);
          let account = JSON.stringify(this.$store.state.account.user);
          setCookie("account", encrypt(account), true);
          this.$toast("用户登录成功.");
        } else {
          this.$toast("用户登录失败.");
        }
      })
    },
  },
  watch: {
    form: {
      handler (value) {
        let info = JSON.stringify(value);
        localStorage.info = info
        this.$store.commit('user/setUserInfo', value);
        this.$emit("changeContent", value);
      },
      deep: true
    },
    "form.phone": function (value) {
      let re = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (re.test(value) && value.length == 11 && this.timer == null) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    code: function (value) {
      if (value == this.smscode) {
        this.verify = true;
        if (this.account.userId) {
          console.log(this)
          this.updateUser()
        } else {
          this.onLogin()
        }
      } else {
        if (value && value.length == 4) {
          this.$toast("验证码不正确.");
        }
      }
    }
  }
};
</script>

<style scoped>
.contentProduct {
  background: #fff;
  margin-top: 0.05rem;
}
.card-header {
  line-height: 0.4rem;
  height: 0.4rem;
  padding: 0 0.175rem;
  border-bottom: solid #efefef 1px;
}
.box-content {
  padding: 0 0.175rem;
}
.box-content .item {
  border-bottom: solid #f5f5f5 1px;
  padding: 0.1rem 0;
  position: relative;
}
.box-content .item .city {
}
.box-content .item label {
  display: inline-block;
  width: 0.6rem;
  float: left;
  margin-top: 0.02rem;
  color: #666;
  font-size: 0.14rem;
}
.box-content .item .value {
  display: inline-block;
  width: 2.8rem;
  float: left;
  margin-top: 0.02rem;
  font-size: 0.14rem;
}
.box-content .item button {
  position: absolute;
  right: 0;
  top: 0.05rem;
}
.box-content .item .cell-value .right {
  font-size: 0.14rem;
}
.box-content .item .value input {
  border: 0;
  width: 100%;
  display: inline-block;
  font-size: 0.14rem;
}
.box-content .item .item-right {
  position: absolute;
  right: 0;
  font-size: 0.18rem;
  color: #999;
}
.addtit {
  padding: 0.1rem 0.15rem;
  border-bottom: solid #e2e2e2 1px;
  background: #fff;
  position: relative;
  color: #888;
}
.addtit i {
  position: absolute;
  right: 0.15rem;
  font-size: 0.24rem;
  top: 0.075rem;
}
</style>
